import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Config} from "../../services/env.config";
@Injectable({
  providedIn: 'root'
})
export class LoginService {

  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };
  

  newHeaders = {
    headers: new HttpHeaders({
      'Authorization': 'TokenId',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'

    })
  };
  constructor(private http: HttpClient) { 
    console.log(Config.LoginEndpoint)
  }
  loginNew(loginData): any {
    return this.http
      .post(Config.LoginEndpoint + '/CheckLoginUser' , JSON.stringify(loginData), this.newHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  login(loginData): any {
    return this.http
      .post(Config.LoginEndpoint, JSON.stringify(loginData), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });

  }


  changePassword(passwordData): any {
    return this.http
      .post(Config.BaseEndpoint + '/ChangePassword', JSON.stringify(passwordData), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  forgotPassword(userName): any {
    return this.http
      .post(Config.BaseEndpoint + 'user/resetNewPassword/' + userName, this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }



  getUserById(userId): any {
    return this.http
      .get(Config.BaseEndpoint + 'user/getUserOnId/' + userId, this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }



 
}
